import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'
import Components from '@/config/components'
import CustomLoading from '@/components/loading.vue'

Vue.use(Components)
Vue.component('custom-loading', CustomLoading)

new Vue({
  el: '#quickly-warranty',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})